"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROMOCODE_AVAILABILITY_TYPE = void 0;
exports.PROMOCODE_AVAILABILITY_TYPE = {
    ONE_TIME_PER_LOGGED_USER: 'ONE_TIME_PER_LOGGED_USER',
    LOGGED_IN_USERS: 'LOGGED_IN_USERS',
    VIP_ONLY: 'VIP_ONLY'
};
//# sourceMappingURL=promocodeAvailabilityType.js.map